import React from 'react'
import "./HomePage.css";
import BlurText from "./BlurText";
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AnimatedContent from './AnimatedContent '
function HomePage() {
    const handleAnimationComplete = () => {
        console.log('Animation completed!');
    };
    return (
        <div className='paddings homePage'>
            <BlurText
                text="Search Your Next Home"
                delay={150}
                animateBy="words"
                direction="top"
                onAnimationComplete={handleAnimationComplete}
                className=" titeleHomePage"
            />
            <BlurText
                text="Find new & featured property located in your local city."
                delay={150}
                animateBy="words"
                direction="top"
                onAnimationComplete={handleAnimationComplete}
                className=" secondaryText"
            />


            <AnimatedContent
                distance={150}
                direction="horizontal"
                reverse={false}
                duration={1.2}
                ease="bounce.out"
                initialOpacity={0.2}
                animateOpacity
                scale={1.1}
                threshold={0.2}
                delay={0.3}
            >
                <div className="inputContainer ">
                    <div className="onlyContainer">
                        <span className='secondaryText'>City/Street</span>
                        <TextField id="outlined-basic" label="location" variant="outlined" />
                    </div>
                    <div className="onlyContainer">
                        <span className='secondaryText'>Property Type</span>
                        <TextField  id="outlined-basic" label="Property Type" variant="outlined" />
                    </div>
                    <div className="onlyContainer">
                        <span className='secondaryText'>Price Range</span>
                        <TextField id="outlined-basic" label="Price Range" variant="outlined" />
                    </div>
                    <div className="lastContainer">
                        <span className='secondaryText'>Advance Filter</span>
                        <Button variant="contained"><SearchIcon /></Button>
                    </div>
                </div>
            </AnimatedContent>
        </div>
    )
}

export default HomePage
